export default __webpack_public_path__ + "static/gamerize-2-a-a30004a5aa3acaa456bcaef3c71720f3.webp";